import {Text} from '@mantine/core'

import type {BoardLane} from './board-lanes'
import classes from './dispatch.module.css'

export const DISPATCH_BOARD_EMPTY_COPY = {
    title: 'No jobs require attention.',
    body: 'New work will appear here as jobs are created or operational issues arise.',
} as const

export const DISPATCH_BOARD_LANE_EMPTY_COPY: Record<BoardLane, string> = {
    needs_action: 'Nothing needs your attention.',
    notify_drivers: 'No jobs need drivers notified.',
    dispatched: 'No jobs dispatched.',
}

export const DISPATCH_CUSTOMER_EMPTY_COPY =
    'No jobs for this customer within the selected time frame.'

/** Quiet per-lane empty message when a board lane has no jobs. */
export function DispatchBoardLaneEmptyMessage({lane}: {lane: BoardLane}) {
    return <div className={classes.laneEmptyMessage}>{DISPATCH_BOARD_LANE_EMPTY_COPY[lane]}</div>
}

/** Quiet empty state — the board at rest, not a first-run onboarding screen. */
export function DispatchBoardEmptyState() {
    return (
        <div className={classes.boardEmptyState} role="status">
            <Text className={classes.boardEmptyTitle}>{DISPATCH_BOARD_EMPTY_COPY.title}</Text>
            <Text className={classes.boardEmptyBody}>{DISPATCH_BOARD_EMPTY_COPY.body}</Text>
        </div>
    )
}

export function DispatchCustomerEmptyState() {
    return (
        <div className={classes.boardEmptyState} role="status">
            <Text className={classes.boardEmptyTitle}>{DISPATCH_CUSTOMER_EMPTY_COPY}</Text>
        </div>
    )
}
